
import {register} from "@benev/slate"
import {Context} from "./context.js"

const context = new Context()

register(context.elements)

